import React, { useState, useEffect, useMemo } from "react";
import ResponsiveDrawer from "../Drawer/drawer";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import * as XLSX from "xlsx";
import axios from "axios";
import Dropdown from "react-bootstrap/Dropdown";
import Notification from "../AlertNotification/Message";
import ConfirmDialog from "../AlertNotification/confirmdialog";
import { BiSearch } from "react-icons/bi";
import CircularIndeterminate from "../Loader/Loader";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useOrderDraft } from "./OrderDraftContext";
import { formatDate } from "../../ReusableComponents/functions";

const drawerWidth = 240;

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        href="#/"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <span className="threedots" />
    </a>
));

const columns = [
    { id: "storeName", label: "Store Name", minWidth: 100, align: "left" },
    { id: "orderNumber", label: "PO#", minWidth: 50, align: "left" },
    { id: "totalPairs", label: "Total\u00a0Pairs", minWidth: 50, align: "left" },
    { id: "totalSales", label: "Total\u00a0$", minWidth: 50, align: "left" },
    { id: "orderDate", label: "Order\u00a0Date", minWidth: 100, align: "left" },
    { id: "shipDate", label: "Ship\u00a0Date", minWidth: 100, align: "left" },
    { id: "cancelDate", label: "Cancel\u00a0Date", minWidth: 100, align: "left" },
    { id: "status", label: "Status", minWidth: 50, align: "left" },
    { id: "action", label: "Action", minWidth: 10, align: "left" },
];

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === "light"
                ? "rgb(55, 65, 81)"
                : theme.palette.grey[300],
        boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
        "& .MuiMenu-list": {
            padding: "4px 0",
        },
        "& .MuiMenuItem-root": {
            "& .MuiSvgIcon-root": {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            "&:active": {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                ),
            },
        },
    },
}));

function OrderHistory() {
    const navigate = useNavigate();
    const { clearCart } = useOrderDraft();

    const [filter, setfilter] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [done, setdone] = useState(false);
    const [orderheading, setorderheading] = useState("All\u00a0Orders");
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
    });
    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    const [downloadProgress, setDownloadProgress] = useState(null);
    const [downloadingOrderId, setDownloadingOrderId] = useState(null);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(1000);

    const [tokenauth, settokenauth] = useState("");
    const [orders, setorders] = useState([]);
    const [factoryready, setfactoryready] = useState([]);
    const [bulkorders, setbulkorders] = useState([]);
    const [factory_ready_prices, setfactory_ready_prices] = useState([]);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const parseDateToTimestamp = (dateStr) => {
        if (!dateStr) return 0;
        const formatted = formatDate(dateStr);
        if (!formatted) return 0;
        const parts = formatted.split(/[-/]/);
        if (parts.length === 3) {
            return new Date(`${parts[2]}-${parts[0]}-${parts[1]}`).getTime() || 0;
        }
        const d = new Date(dateStr).getTime();
        return isNaN(d) ? 0 : d;
    };

    const commafunc = (amount) => {
        if (amount === undefined || amount === null || amount === "") return "$0.00";
        const num = Number(amount);
        if (isNaN(num)) return "$0.00";
        return num.toLocaleString("en-US", { style: "currency", currency: "USD" });
    };

    // Sort Handlers
    const PO = () => {
        setSortConfig({ key: "orderNumber", direction: "asc" });
        handleClose();
    };
    const PODown = () => {
        setSortConfig({ key: "orderNumber", direction: "desc" });
        handleClose();
    };
    const Start = () => {
        setSortConfig({ key: "orderDate", direction: "desc" });
        handleClose();
    };
    const StartDown = () => {
        setSortConfig({ key: "orderDate", direction: "asc" });
        handleClose();
    };
    const Price = () => {
        setSortConfig({ key: "totalSales", direction: "desc" });
        handleClose();
    };
    const PriceUp = () => {
        setSortConfig({ key: "totalSales", direction: "asc" });
        handleClose();
    };
    const TotalPairsDown = () => {
        setSortConfig({ key: "totalPairs", direction: "desc" });
        handleClose();
    };
    const TotalPairsUp = () => {
        setSortConfig({ key: "totalPairs", direction: "asc" });
        handleClose();
    };
    const StoreName = () => {
        setSortConfig({ key: "storeName", direction: "asc" });
        handleClose();
    };
    const StoreNameDown = () => {
        setSortConfig({ key: "storeName", direction: "desc" });
        handleClose();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleFilterChange = (e) => {
        setfilter(e.target.value);
        setPage(0);
    };

    const getorders = () => {
        axios
            .post("/get-token", {
                id: sessionStorage.getItem("token_id"),
            })
            .then((res) => {
                settokenauth(res.data.token);
                axios
                    .get("/order-history-admin", {
                        headers: {
                            "x-auth-header": res.data.token,
                        },
                    })
                    .then((resp) => {
                        setorders(resp.data || []);
                        setdone(false);
                    })
                    .catch((err) => {
                        console.log(err.response);
                        setdone(false);
                    });
            })
            .catch((err) => {
                console.log(err.response);
                setdone(false);
            });
    };

    const GetFactoryReady = async () => {
        try {
            const response = await axios.post(
                `/factory-ready-orders`,
                {},
                {
                    headers: {
                        "x-auth-header": sessionStorage.getItem("token"),
                    },
                }
            );
            setfactoryready(response.data || []);
        } catch (err) {
            console.error("Error fetching factory ready orders:", err);
        }
    };

    const GetBulkOrders = async () => {
        try {
            const response = await axios.post(
                `/bulk-ready-orders`,
                {},
                {
                    headers: {
                        "x-auth-header": sessionStorage.getItem("token"),
                    },
                }
            );
            setbulkorders(response.data || []);
        } catch (err) {
            console.error("Error fetching bulk orders:", err);
        }
    };

    const Factory_Prices = async () => {
        try {
            const response = await axios.post(
                `/factory-ready-prices`,
                {},
                {
                    headers: {
                        "x-auth-header": sessionStorage.getItem("token"),
                    },
                }
            );
            setfactory_ready_prices(response.data || []);
        } catch (err) {
            console.error("Error fetching factory prices:", err);
        }
    };

    useEffect(() => {
        if (sessionStorage.getItem("payloadout") !== "true") {
            navigate("/");
            return;
        }
        sessionStorage.setItem("id", "5");
        setdone(true);
        GetFactoryReady();
        GetBulkOrders();
        Factory_Prices();
        getorders();
    }, [navigate]);

    const HandleAllOrders = () => {
        setorderheading("All\u00a0Orders");
        navigate("/OrderHistory");
        handleClose();
    };
    const HandleCompleteOrders = () => {
        setorderheading("Active\u00a0Orders");
        navigate("/CompleteOrders");
        handleClose();
    };
    const HandleActiveOrders = () => {
        setorderheading("Active\u00a0Orders");
        navigate("/PendingOrders");
        handleClose();
    };
    const HandleCancelOrders = () => {
        setorderheading("Canceled\u00a0Orders");
        navigate("/CancelledOrders");
        handleClose();
    };

    const handleDelete = (orderno) => {
        setdone(true);
        axios
            .post(
                "/delete-order",
                {
                    order_number: orderno,
                },
                {
                    headers: {
                        "x-auth-header": tokenauth,
                    },
                }
            )
            .then((response) => {
                setdone(false);
                if (response.status === 200) {
                    setNotify({
                        isOpen: true,
                        message: `${response.data.message}`,
                        type: "success",
                    });
                }
                getorders();
            })
            .catch((err) => {
                setdone(false);
                setNotify({
                    isOpen: true,
                    message: `${err.response?.data?.message || "Error deleting order"}`,
                    type: "error",
                });
            });
    };

    const ExportexcelFactory = () => {
        setdone(true);
        const transformedData = factoryready.map((item) => {
            const nonSizeEntries = [];
            const sizeEntries = [];
            let totalQty = 0;

            Object.entries(item).forEach(([key, value]) => {
                if (key.startsWith("size#")) {
                    const sizeNumber = key.replace("size#", "");
                    const numValue = parseInt(value, 10) || 0;
                    totalQty += numValue;
                    sizeEntries.push([
                        `size_${sizeNumber}`,
                        value === 0 || value === "0" ? "" : value,
                    ]);
                } else {
                    nonSizeEntries.push([key, value]);
                }
            });

            return Object.fromEntries([
                ...nonSizeEntries,
                ...sizeEntries,
                ["QTY", totalQty],
            ]);
        });

        const workSheet = XLSX.utils.json_to_sheet(transformedData);
        const range = XLSX.utils.decode_range(workSheet["!ref"]);
        for (let col = range.s.c; col <= range.e.c; col++) {
            const headerCell = workSheet[XLSX.utils.encode_cell({ r: 0, c: col })];
            if (
                headerCell &&
                headerCell.v &&
                typeof headerCell.v === "string" &&
                headerCell.v.startsWith("size_")
            ) {
                headerCell.v = headerCell.v.replace("size_", "");
            }
        }
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, "order");
        const today = new Date().toLocaleDateString();
        XLSX.writeFile(workBook, `FactoryReadyExport-${today}.xlsx`);
        setdone(false);
    };

    const ExportexcelBulk = () => {
        setdone(true);
        const formattedBulkOrders = bulkorders.map((order) => ({
            ...order,
            revenuesTotal: parseFloat(order.revenuesTotal || 0).toFixed(2),
            factory: parseInt(order.factory || 0, 10),
        }));

        const workSheet = XLSX.utils.json_to_sheet(formattedBulkOrders);
        if (!workSheet["!cols"]) workSheet["!cols"] = [];
        workSheet["!cols"][1] = { numFmt: "0.00" };
        workSheet["!cols"][8] = { numFmt: "0" };

        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, "order");
        const today = new Date().toLocaleDateString();
        XLSX.writeFile(workBook, `BulkExport-${today}.xlsx`);
        setdone(false);
    };

    const FactoryPrices = () => {
        setdone(true);
        const workSheet = XLSX.utils.json_to_sheet(factory_ready_prices);
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, "order");
        const today = new Date().toLocaleDateString();
        XLSX.writeFile(workBook, `FactoryPricesExport-${today}.xlsx`);
        setdone(false);
    };

    const updateOrderStatus = (orderno, status) => {
        setdone(true);
        axios
            .post(
                "/change-order-status",
                {
                    order_number: orderno,
                    status: status,
                },
                {
                    headers: {
                        "x-auth-header": tokenauth,
                    },
                }
            )
            .then((response) => {
                setdone(false);
                if (response.status === 200) {
                    setNotify({
                        isOpen: true,
                        message: `${response.data.message}`,
                        type: "success",
                    });
                }
                getorders();
            })
            .catch((err) => {
                setdone(false);
                setNotify({
                    isOpen: true,
                    message: `${err.response?.data?.message || "Error updating order status"}`,
                    type: "error",
                });
            });
    };

    const ChangeStatusCancel = (orderno) => updateOrderStatus(orderno, "0");
    const ChangeStatusPending = (orderno) => updateOrderStatus(orderno, "1");
    const ChangeStatusComplete = (orderno) => updateOrderStatus(orderno, "2");

    const DeleteAllOrders = () => {
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        setdone(true);
        axios
            .post(
                "/delete-all-orders",
                {},
                {
                    headers: {
                        "x-auth-header": tokenauth,
                    },
                }
            )
            .then((response) => {
                setdone(false);
                if (response.status === 200) {
                    setNotify({
                        isOpen: true,
                        message: "All Orders Deleted Successfully",
                        type: "success",
                    });
                }
                getorders();
            })
            .catch((err) => {
                setdone(false);
                setNotify({
                    isOpen: true,
                    message: `${err.response?.data?.message || "Error deleting all orders"}`,
                    type: "error",
                });
            });
    };

    const downloadBulkOrders = async () => {
        try {
            setdone(true);
            setDownloadProgress({
                current: 0,
                total: 0,
                percentage: 0,
                text: "Initializing bulk download job..."
            });
            const order_ids = orders.map(({ orderNumber }) => orderNumber);
            const startResponse = await axios.post(
                "/bulk-order-pdf-download/start",
                { order_number: order_ids },
                {
                    headers: {
                        "x-auth-header": tokenauth,
                    }
                }
            );

            const { jobId, total } = startResponse.data;
            setDownloadProgress({
                current: 0,
                total: total,
                percentage: 0,
                text: `Starting download of ${total} PDFs...`
            });

            let jobStatus = "processing";
            let jobData = null;

            while (jobStatus === "processing") {
                await new Promise(resolve => setTimeout(resolve, 800));
                const statusResponse = await axios.get(
                    `/bulk-order-pdf-download/status/${jobId}`,
                    {
                        headers: {
                            "x-auth-header": tokenauth,
                        }
                    }
                );
                jobData = statusResponse.data;
                jobStatus = jobData.status;

                if (jobStatus === "processing" || jobStatus === "completed") {
                    const percentage = Math.round((jobData.current / jobData.total) * 100);
                    setDownloadProgress({
                        current: jobData.current,
                        total: jobData.total,
                        percentage: percentage,
                        text: jobStatus === "completed"
                            ? "Zipping files, preparing download..."
                            : `Archiving order PDF ${jobData.current} of ${jobData.total}...`
                    });
                }
            }

            if (jobStatus === "completed") {
                const baseURL = axios.defaults.baseURL || "";
                const downloadUrl = `${baseURL}/bulk-order-pdf-download/file/${jobId}?token=${tokenauth}`;

                const link = document.createElement("a");
                link.href = downloadUrl;

                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                const hours = String(now.getHours()).padStart(2, '0');
                const minutes = String(now.getMinutes()).padStart(2, '0');
                const seconds = String(now.getSeconds()).padStart(2, '0');
                const zipName = `orders_${year}-${month}-${day}_${hours}${minutes}${seconds}.zip`;

                link.setAttribute("download", zipName);
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                throw new Error(jobData?.error || "Bulk download job failed");
            }

        } catch (error) {
            console.error("Error in bulk download pdf: ", error);
            let errorMessage = "Error in bulk downloading PDFs";
            if (error.response && error.response.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    const parsed = JSON.parse(text);
                    if (parsed && parsed.message) {
                        errorMessage = parsed.message;
                    }
                } catch (e) {
                    console.error("Failed to parse error response blob", e);
                }
            } else if (error.message) {
                errorMessage = error.message;
            }
            setNotify({
                isOpen: true,
                message: errorMessage,
                type: "error",
            });
        } finally {
            setdone(false);
            setDownloadProgress(null);
        }
    };

    const handleDownloadPDF = async (admin) => {
        if (!admin?.orderNumber) return;

        try {
            setDownloadingOrderId(admin.orderNumber);
            setNotify({
                isOpen: true,
                message: `Fetching PDF for Order #${admin.orderNumber}...`,
                type: "info",
            });

            let pdfUrl = admin?.orderPdf || admin?.pdf || null;

            if (!pdfUrl) {
                let token = tokenauth;
                if (!token) {
                    try {
                        const tokenRes = await axios.post("/get-token", {
                            id: sessionStorage.getItem("token_id"),
                        });
                        token = tokenRes.data.token;
                        settokenauth(token);
                    } catch (tokenErr) {
                        token = sessionStorage.getItem("token");
                    }
                }

                const res = await axios.post(
                    "/get-pdf",
                    {
                        order_number: admin.orderNumber,
                    },
                    {
                        headers: {
                            "x-auth-header": token,
                        },
                    }
                );

                const data = res.data;
                pdfUrl = Array.isArray(data)
                    ? (data.length > 0 ? data[0]?.file : null)
                    : (data?.file || null);
            }

            if (!pdfUrl || pdfUrl === "#") {
                setNotify({
                    isOpen: true,
                    message: `Order PDF not generated for Order #${admin.orderNumber}`,
                    type: "error",
                });
                return;
            }

            const cleanStoreName = (admin?.storeName || "").trim() || "Store";
            const fileName = `${cleanStoreName}_${admin.orderNumber}.pdf`;

            let targetUrl = pdfUrl;
            if (!targetUrl.startsWith("http://") && !targetUrl.startsWith("https://")) {
                const baseURL = axios.defaults.baseURL || "";
                targetUrl = `${baseURL}${targetUrl.startsWith("/") ? "" : "/"}${targetUrl}`;
            }

            try {
                const response = await fetch(targetUrl);
                if (!response.ok) throw new Error("Network response was not ok");
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(blobUrl);
            } catch (fetchErr) {
                // Fallback for CORS or fetch restrictions
                const link = document.createElement("a");
                link.href = targetUrl;
                link.target = "_blank";
                link.rel = "noopener noreferrer";
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                link.remove();
            }

            setNotify({
                isOpen: true,
                message: `Order #${admin.orderNumber} PDF downloaded successfully`,
                type: "success",
            });
        } catch (error) {
            console.error("Error downloading order PDF:", error);
            setNotify({
                isOpen: true,
                message: "Failed to download order PDF",
                type: "error",
            });
        } finally {
            setDownloadingOrderId(null);
        }
    };

    // Filter and Sort logic using useMemo
    const filteredAndSortedOrders = useMemo(() => {
        let result = [...orders];

        // Search Filter (applied to FULL dataset before pagination)
        if (filter && filter.trim() !== "") {
            const searchTerm = filter.trim().toLowerCase();
            result = result.filter((admin) => {
                const orderNum = admin.orderNumber ? String(admin.orderNumber).toLowerCase() : "";
                const sku = admin.sku ? String(admin.sku).toLowerCase() : "";
                const store = admin.storeName ? String(admin.storeName).toLowerCase() : "";
                return orderNum.includes(searchTerm) || sku.includes(searchTerm) || store.includes(searchTerm);
            });
        }

        // Sorting
        if (sortConfig.key) {
            result.sort((a, b) => {
                let valA, valB;
                if (sortConfig.key === "orderNumber") {
                    valA = Number(a.orderNumber) || 0;
                    valB = Number(b.orderNumber) || 0;
                } else if (sortConfig.key === "totalPairs") {
                    valA = Number(a.totalPairs) || 0;
                    valB = Number(b.totalPairs) || 0;
                } else if (sortConfig.key === "orderDate") {
                    valA = parseDateToTimestamp(a.orderDate || a.date || a.startDate);
                    valB = parseDateToTimestamp(b.orderDate || b.date || b.startDate);
                } else if (sortConfig.key === "totalSales") {
                    valA = Number(a.totalSales) || 0;
                    valB = Number(b.totalSales) || 0;
                } else if (sortConfig.key === "storeName") {
                    valA = a.storeName ? String(a.storeName).toLowerCase() : "";
                    valB = b.storeName ? String(b.storeName).toLowerCase() : "";
                }

                if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
                if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
                return 0;
            });
        }

        return result;
    }, [orders, filter, sortConfig]);

    const paginatedOrders = useMemo(() => {
        return filteredAndSortedOrders.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
        );
    }, [filteredAndSortedOrders, page, rowsPerPage]);

    return (
        <div className="tableX">
            <ResponsiveDrawer heading="Order Management" />
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
                component="main"
            >
                <Toolbar />
                <div className="position-relative">
                    <div className="d-flex justify-content-between mt-3 p-4">
                        <h4 className="">{orderheading}</h4>
                        <div className="Accordian overflow-auto">
                            <div className="mx-2">
                                <div className="btncsv">
                                    <button
                                        className="CSV btn1 mb-3 px-2"
                                        onClick={() => {
                                            clearCart();
                                            navigate('/SelectCustomer');
                                        }}
                                    >
                                        <small>Create&nbsp;Order</small>
                                    </button>
                                </div>
                            </div>

                            <div className="mx-2">
                                <div className="btncsv">
                                    <button
                                        className="CSV btn1 mb-3 px-2"
                                        onClick={downloadBulkOrders}
                                    >
                                        <small>Bulk&nbsp;Orders&nbsp;Download</small>
                                    </button>
                                </div>
                            </div>

                            <div className="one">
                                <div className="btncsv">
                                    <button
                                        className="CSV btn1 mb-3 px-3"
                                        onClick={ExportexcelFactory}
                                    >
                                        <small>FactoryReady&nbsp;Export </small>
                                    </button>
                                </div>
                            </div>

                            <div className="mx-2">
                                <div className="btncsv">
                                    <button
                                        className="CSV btn1 mb-3 px-2"
                                        onClick={ExportexcelBulk}
                                    >
                                        <small>Bulk&nbsp;Export</small>
                                    </button>
                                </div>
                            </div>

                            <div className="mx-2">
                                <div className="btncsv">
                                    <button
                                        className="CSV btn1 mb-3 px-2"
                                        onClick={FactoryPrices}
                                    >
                                        <small>Factory&nbsp;Ready&nbsp;Prices&nbsp;Export</small>
                                    </button>
                                </div>
                            </div>

                            <div className="ImportCSV1">
                                <div className="ms-2">
                                    <button
                                        className="btnxcv mb-3 px-3"
                                        onClick={() => {
                                            setConfirmDialog({
                                                isOpen: true,
                                                title: "Delete All Orders?",
                                                subTitle: "You can't undo this operation",
                                                onConfirm: () => {
                                                    DeleteAllOrders();
                                                },
                                            });
                                        }}
                                    >
                                        <small>Delete&nbsp;All&nbsp;Orders</small>
                                    </button>
                                </div>
                            </div>

                            <div className="ImportCSV1">
                                <div className="sorting">
                                    <div>
                                        <Button
                                            id="demo-customized-button"
                                            aria-controls="demo-customized-menu"
                                            aria-haspopup="true"
                                            aria-expanded={open ? "true" : undefined}
                                            disableElevation
                                            onClick={handleClick}
                                            endIcon={
                                                <KeyboardArrowDownIcon style={{ color: "#f00e0e" }} />
                                            }
                                        >
                                            <span className="fw-bolder text-dark">Sort&nbsp;By</span>
                                        </Button>
                                        <StyledMenu
                                            id="demo-customized-menu"
                                            MenuListProps={{
                                                "aria-labelledby": "demo-customized-button",
                                            }}
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                        >
                                            <MenuItem disableRipple onClick={PODown}>
                                                PO&nbsp;
                                                <ArrowDownwardIcon className="ml-auto" />
                                            </MenuItem>
                                            <MenuItem disableRipple onClick={PO}>
                                                PO&nbsp;
                                                <ArrowUpwardIcon className="ml-auto" />
                                            </MenuItem>

                                            <MenuItem disableRipple onClick={Start}>
                                                Start&nbsp;Date&nbsp;
                                                <ArrowDownwardIcon className="ml-auto" />
                                            </MenuItem>
                                            <MenuItem disableRipple onClick={StartDown}>
                                                Start&nbsp;Date&nbsp;
                                                <ArrowUpwardIcon className="ml-auto" />
                                            </MenuItem>

                                            <MenuItem disableRipple onClick={Price}>
                                                Price&nbsp;
                                                <ArrowDownwardIcon className="ml-auto" />
                                            </MenuItem>
                                            <MenuItem disableRipple onClick={PriceUp}>
                                                Price&nbsp;
                                                <ArrowUpwardIcon className="ml-auto" />
                                            </MenuItem>

                                            <MenuItem disableRipple onClick={TotalPairsDown}>
                                                Total&nbsp;Pairs&nbsp;
                                                <ArrowDownwardIcon className="ml-auto" />
                                            </MenuItem>
                                            <MenuItem disableRipple onClick={TotalPairsUp}>
                                                Total&nbsp;Pairs&nbsp;
                                                <ArrowUpwardIcon className="ml-auto" />
                                            </MenuItem>

                                            <MenuItem disableRipple onClick={StoreNameDown}>
                                                Store&nbsp;Name&nbsp;
                                                <ArrowDownwardIcon className="ml-auto" />
                                            </MenuItem>
                                            <MenuItem disableRipple onClick={StoreName}>
                                                Store&nbsp;Name&nbsp;
                                                <ArrowUpwardIcon className="ml-auto" />
                                            </MenuItem>

                                            <MenuItem disableRipple onClick={HandleActiveOrders}>
                                                Pending&nbsp;Orders
                                            </MenuItem>
                                            <MenuItem disableRipple onClick={HandleCompleteOrders}>
                                                Completed&nbsp;Orders
                                            </MenuItem>
                                            <MenuItem disableRipple onClick={HandleCancelOrders}>
                                                Cancelled&nbsp;Orders
                                            </MenuItem>
                                            <MenuItem disableRipple onClick={HandleAllOrders}>
                                                All&nbsp;Orders
                                            </MenuItem>
                                        </StyledMenu>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="jhhgg">
                        <div className="d-flex justify-content-between mx-2">
                            <small className="ms-4 fw-bolder mt-1">Search&nbsp;By</small>
                            <div className="position-relative w-75 me-3">
                                <Form onSubmit={(e) => e.preventDefault()}>
                                    <Form.Control
                                        placeholder="PO#, StoreName or SKU"
                                        type="search"
                                        className="input_field"
                                        value={filter}
                                        onChange={handleFilterChange}
                                    />
                                    <BiSearch className="search_Agent" />
                                </Form>
                            </div>
                        </div>

                        {done ? (
                            <CircularIndeterminate className="resetLoading" />
                        ) : orders.length > 0 ? (
                            <div className="for__table m-4">
                                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                                    <TableContainer sx={{ height: "calc(100vh - 260px)", overflow: "auto" }}>
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            style={{ minWidth: column.minWidth }}
                                                        >
                                                            {column.label}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {paginatedOrders.length > 0 ? (
                                                    paginatedOrders.map((admin) => {
                                                        const isPending = String(admin.status) === "1";
                                                        const isCompleted = String(admin.status) === "2";
                                                        const isCanceled = String(admin.status) === "0";

                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={admin._id || admin.orderNumber}
                                                            >
                                                                <TableCell>{admin.storeName}</TableCell>
                                                                <TableCell>{admin.orderNumber}</TableCell>
                                                                <TableCell>{admin.totalPairs}</TableCell>
                                                                <TableCell>{commafunc(admin.totalSales)}</TableCell>
                                                                <TableCell>{formatDate(admin.orderDate || admin.date || admin.startDate)}</TableCell>
                                                                <TableCell>{formatDate(admin.shipDate || admin.startDate)}</TableCell>
                                                                <TableCell>{formatDate(admin.cancelDate)}</TableCell>
                                                                <TableCell>
                                                                    {isPending ? (
                                                                        <div style={{ color: "green" }}>
                                                                            <small>Pending</small>
                                                                        </div>
                                                                    ) : isCompleted ? (
                                                                        <div style={{ color: "blue" }}>
                                                                            <small>Completed</small>
                                                                        </div>
                                                                    ) : isCanceled ? (
                                                                        <div style={{ color: "red" }}>
                                                                            <small>Canceled</small>
                                                                        </div>
                                                                    ) : (
                                                                        <div style={{ color: "red" }}>
                                                                            <small>Not Available</small>
                                                                        </div>
                                                                    )}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <div className="App">
                                                                        <Dropdown>
                                                                            <Dropdown.Toggle as={CustomToggle} />
                                                                            <Dropdown.Menu>
                                                                                <Dropdown.Item className="bg-white">
                                                                                    <span
                                                                                        onClick={() => navigate(`/PurchaseOrder/${admin.orderNumber}`)}
                                                                                        className="abc"
                                                                                    >
                                                                                        View
                                                                                    </span>
                                                                                </Dropdown.Item>

                                                                                {!isCanceled && (
                                                                                    <Dropdown.Item className="bg-white">
                                                                                        <span
                                                                                            onClick={() => ChangeStatusCancel(admin.orderNumber)}
                                                                                            className="abc"
                                                                                        >
                                                                                            Cancel
                                                                                        </span>
                                                                                    </Dropdown.Item>
                                                                                )}

                                                                                {!isCompleted && (
                                                                                    <Dropdown.Item className="bg-white">
                                                                                        <span
                                                                                            onClick={() => ChangeStatusComplete(admin.orderNumber)}
                                                                                            className="abc"
                                                                                        >
                                                                                            Complete
                                                                                        </span>
                                                                                    </Dropdown.Item>
                                                                                )}

                                                                                {!isPending && (
                                                                                    <Dropdown.Item className="bg-white">
                                                                                        <span
                                                                                            onClick={() => ChangeStatusPending(admin.orderNumber)}
                                                                                            className="abc"
                                                                                        >
                                                                                            Pending
                                                                                        </span>
                                                                                    </Dropdown.Item>
                                                                                )}

                                                                                <Dropdown.Item className="bg-white">
                                                                                    <span
                                                                                        onClick={() => handleDelete(admin.orderNumber)}
                                                                                        className="abc"
                                                                                    >
                                                                                        Delete
                                                                                    </span>
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item className="bg-white">
                                                                                    <span
                                                                                        onClick={() => handleDownloadPDF(admin)}
                                                                                        className="abc"
                                                                                        style={{ cursor: "pointer" }}
                                                                                    >
                                                                                        {downloadingOrderId === admin.orderNumber
                                                                                            ? "Downloading..."
                                                                                            : "Download PDF"}
                                                                                    </span>
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={columns.length} align="center">
                                                            <small className="text-danger">NO DATA!</small>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        className="mx-5 mt-3 px-5"
                                        rowsPerPageOptions={[100, 500, 1000, 2000]}
                                        component="div"
                                        count={filteredAndSortedOrders.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </div>
                        ) : (
                            <small className="text-danger mx-5 my-5">No Orders Found!</small>
                        )}
                    </div>
                </div>
            </Box>

            {downloadProgress && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    <div style={{
                        backgroundColor: "#fff",
                        padding: "30px",
                        borderRadius: "8px",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                        width: "400px",
                        textAlign: "center"
                    }} className="bg-white">
                        <h5 className="mb-3 text-dark">Generating Bulk PDF ZIP</h5>
                        <div className="progress mb-2" style={{ height: "20px" }}>
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated bg-danger"
                                role="progressbar"
                                style={{ width: `${downloadProgress.percentage}%`, height: "20px" }}
                                aria-valuenow={downloadProgress.percentage}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            >
                                {downloadProgress.percentage}%
                            </div>
                        </div>
                        <small className="text-muted d-block mt-2">
                            {downloadProgress.text}
                        </small>
                        {downloadProgress.percentage === 100 && (
                            <div style={{
                                marginTop: "20px",
                                padding: "16px",
                                background: "linear-gradient(135deg, #fffcf6 0%, #fff8eb 100%)",
                                border: "1px solid #ffe8cc",
                                borderRadius: "12px",
                                textAlign: "left",
                                fontSize: "13px",
                                lineHeight: "1.6",
                                boxShadow: "0 4px 12px rgba(230, 119, 0, 0.05)",
                                position: "relative",
                                overflow: "hidden",
                                animation: "pulseGlow 2s infinite ease-in-out"
                            }}>
                                <div style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "12px"
                                }}>
                                    <span style={{
                                        fontSize: "20px",
                                        lineHeight: "1",
                                        animation: "bounceIcon 1.2s infinite alternate ease-in-out",
                                        display: "inline-block"
                                    }}>
                                        📦
                                    </span>
                                    <div>
                                        <strong style={{ display: "block", color: "#e67e22", marginBottom: "4px", fontSize: "14px" }}>
                                            Almost done at 100%
                                        </strong>
                                        <span style={{ color: "#495057", fontWeight: "500" }}>
                                            When the bar reaches the end, we're still zipping everything into a single file. Stay on this page and your download will start on its own.
                                        </span>
                                    </div>
                                </div>
                                <style>{`
                                    @keyframes pulseGlow {
                                        0% { box-shadow: 0 4px 12px rgba(230, 119, 0, 0.05); border-color: #ffe8cc; }
                                        50% { box-shadow: 0 4px 20px rgba(230, 119, 0, 0.15); border-color: #ffcc99; }
                                        100% { box-shadow: 0 4px 12px rgba(230, 119, 0, 0.05); border-color: #ffe8cc; }
                                    }
                                    @keyframes bounceIcon {
                                        0% { transform: translateY(0); }
                                        100% { transform: translateY(-4px); }
                                    }
                                `}</style>
                            </div>
                        )}
                    </div>
                </div>
            )}

            <Notification notify={notify} setNotify={setNotify} />

            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
        </div>
    );
}

export default OrderHistory;
